<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <div id="filterList" class="filterList">
    <div
      v-if="filterDataset.resultsString"
      :class="[
        filterDataset.gridType === 'ArticlesList' ? 'container' : null,
        filterDataset.gridType === 'ProductsList' ? 'container--plp' : null,
        filterDataset.gridType === 'ArticlesListTwoColumns' &&
        filterDataset.cardType === 'ArticleCard'
          ? 'container--articles'
          : null,
        isLayoutTwoColumns ? 'container--plp container--two-columns' : null,
        isLayoutSearchPage ? 'container--search-page' : null,
      ]"
    >
      <div class="filterList__panelWrapper">
        <div v-if="isLayoutWithFilters" class="filterList__panel">
          <template v-if="isLayoutSearchPage">
            <span class="filterList__qty">
              <span role="status"> {{ totalResultsCount }} {{ filterDataset.resultsLabel }} </span>
            </span>

            <div class="filterList__tabs-wrapper">
              <div class="filterList__tab">
                <button
                  :class="[
                    'filterList__tab-content',
                    filterDataset.gridType === 'ProductsListTwoColumns' ? '-active' : null,
                  ]"
                  @click="switchToProducts"
                >
                  <template v-if="initialdata.list">
                    {{ initialdata.dictionary.searchPageLabel }} ({{ initialdata.resultsCount }})
                  </template>
                  <template v-else>
                    {{ productsLabel }}
                    (0)
                  </template>
                </button>
              </div>

              <div class="filterList__tab">
                <button
                  :class="[
                    'filterList__tab-content',
                    filterDataset.gridType === 'ArticlesListTwoColumns' ? '-active' : null,
                  ]"
                  @click="switchToArticles"
                >
                  <template v-if="articles.list">
                    {{ articles.dictionary.searchPageLabel }} ({{ articles.resultsCount }})
                  </template>
                  <template v-else>
                    {{ articlesLabel }}
                    (0)
                  </template>
                </button>
              </div>
            </div>
          </template>

          <div id="filterList__sort" class="filterList__sort">
            <span v-if="!isLayoutSearchPage" class="filterList__qty">
              <span role="status">{{ filterDataset.resultsString }}</span>
            </span>

            <template v-if="showFilterOptions">
              <FilterSorting
                :grid-type="filterDataset.gridType"
                :sorting-label="filterDataset.dictionary.sortingLabel"
                :sorting-options="filterDataset.sortingOptions"
              />
            </template>

            <template v-if="isLayoutTwoColumns">
              <button class="filterList__toggleFilterAccordion" @click="dialogIsOpen = true">
                {{ filterDataset.dictionary.filterTitle }}
                {{ selectedTags.length === 0 ? '' : `(${selectedTags.length})` }}
              </button>
            </template>
          </div>

          <button
            v-if="!isLayoutTwoColumns"
            id="toggle-facets"
            class="filterList__toggleFacets"
            :class="{ '-expanded': facetsOpened }"
            :aria-expanded="facetsOpened.toString()"
            @click="onToggleFacets"
          >
            <span
              v-if="filterDataset.dictionary && filterDataset.dictionary.filterTitle"
              class="filterList__toggleText"
            >
              <span v-if="!facetsOpened"> {{ filterDataset.dictionary.filterTitle }}</span>
              <span v-if="facetsOpened"> {{ filterDataset.dictionary.expandedFilterTitle }}</span>
              <svg v-if="!facetsOpened" class="filterList__toggleIcon" :aria-hidden="true">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#filter" />
              </svg>
              <svg v-if="facetsOpened" class="filterList__toggleIcon" :aria-hidden="true">
                <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#close" />
              </svg>
            </span>
          </button>
        </div>
        <template v-if="!isLayoutTwoColumns">
          <template v-if="isLayoutWithFilters">
            <Facets v-if="facetsOpened" :facet-dataset="filterDataset" />
            <selected-filters
              v-if="!facetsOpened"
              :selected-dataset="filterDataset"
              :aria-label-key="ariaLabelKeySelectedFilters"
            ></selected-filters>
          </template>
          <div v-show="showOverlay" class="loadingOverlay">
            <div class="loaderContainer">
              <OapLoader />
            </div>
          </div>
        </template>
      </div>
    </div>

    <div
      :class="[
        filterDataset.gridType === 'ProductsList' ? 'container--plp' : null,

        filterDataset.gridType === 'ArticlesListTwoColumns' &&
        filterDataset.cardType === 'ArticleCard'
          ? 'container--articles'
          : null,

        isLayoutTwoColumns === true ? 'container--plp container--two-columns' : null,
        isLayoutSearchPage === true ? 'container--search-page' : null,
      ]"
    >
      <template v-if="isLayoutTwoColumns && !smallScreen">
        <div class="container--two-columns__wrapper">
          <div class="container--two-columns__side-col">
            <FilterShortcutLinks
              v-if="currentGridData.shortcutLinks?.list?.length"
              :shortcuts="currentGridData.shortcutLinks"
            ></FilterShortcutLinks>
            <FilterAccordion
              :initial-data="currentGridData"
              :show-overlay="showOverlay"
              no-loader
            ></FilterAccordion>
          </div>
          <div class="container--two-columns__main">
            <div v-if="showOverlay" class="container--two-columns__overlay"></div>
            <slot name="promo-banner"></slot>
            <Grid
              :grid-dataset="filterDataset"
              :display-review-count="displayReviewCount"
              :wishlist-img="wishlistImg"
              :unwishlist-img="unwishlistImg"
              :wishlist-alt="wishlistAlt"
              :unwishlist-alt="unwishlistAlt"
              :is-article-wishlist-enabled="isArticleWishlistEnabled"
              :is-product-wishlist-enabled="isProductWishlistEnabled"
            />
            <Loadmore :grid-dataset="filterDataset" />
          </div>
        </div>
      </template>
      <template v-else>
        <div v-if="showOverlay" class="container--two-columns__overlay"></div>
        <slot name="promo-banner"></slot>
        <Grid
          :grid-dataset="filterDataset"
          :display-review-count="displayReviewCount"
          :wishlist-img="wishlistImg"
          :unwishlist-img="unwishlistImg"
          :wishlist-alt="wishlistAlt"
          :unwishlist-alt="unwishlistAlt"
          :is-article-wishlist-enabled="isArticleWishlistEnabled"
          :is-product-wishlist-enabled="isProductWishlistEnabled"
        />
        <Loadmore :grid-dataset="filterDataset" />
      </template>
    </div>

    <div
      v-if="filterDataset.banner && filterDataset.banner.textField"
      class="rich-text filterTextField"
      v-html="filterDataset.banner.textField"
    ></div>
    <div
      v-else-if="currentGridData.textField"
      class="rich-text filterTextField"
      v-html="currentGridData.textField"
    ></div>

    <OapFocusTrap :is-visible="dialogIsOpen">
      <transition name="modal">
        <div v-if="dialogIsOpen" role="dialog" aria-modal="true">
          <div class="container--two-columns__filter-dialog">
            <FilterAccordion
              :initial-data="currentGridData"
              :tags-data="{
                tagsCollection: tagsCollection,
                selectedTags: selectedTags,
                selectedBrands: selectedBrands,
              }"
              :show-overlay="showOverlay"
            ></FilterAccordion>
          </div>
        </div>
      </transition>
    </OapFocusTrap>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, createStore } from 'vuex';
import store from '../store';

import { MqHandler } from '../../../../../Foundation/Core/code/Scripts/mqHandler';
import eventBus from '@loreal/eventbus-js';
import FilterAccordion from './filter-accordion.vue';
import Facets from './facets.vue';
import FilterSorting from './filter-sorting.vue';
import Grid from './grid.vue';
import FilterShortcutLinks from './filter-shortcut-links.vue';
import OapFocusTrap from '../../../../OapFocusTrap/code/Scripts/components/OapFocusTrap.vue';
import OapLoader from '../../../../OapLoader/code/Scripts/components/OapLoader.vue';
import { HERO_VIDEO_UPDATE } from '../constants/eventNames';
import Loadmore from './load-more.vue';
import { AnalyticsHandler } from '../../../../../Foundation/Core/code/Scripts';

export default {
  name: 'FilterList',

  components: {
    Facets,
    FilterSorting,
    FilterAccordion,
    FilterShortcutLinks,
    Grid,
    OapFocusTrap,
    OapLoader,
    Loadmore,
  },

  props: {
    initialdata: { type: Object, required: true },
    articles: { type: Object, default: () => {} },
    ariaLabelKeySelectedFilters: { type: String, default: 'Remove: ' },

    productsLabel: { type: String, default: '' },
    articlesLabel: { type: String, default: '' },

    isLayoutSearchPage: {
      type: Boolean,
      default: false,
    },

    isLayoutWithFilters: {
      type: Boolean,
      default: true,
    },

    displayReviewCount: {
      type: Boolean,
      default: false,
    },
    wishlistImg: {
      type: String,
      default: '',
    },
    unwishlistImg: {
      type: String,
      default: '',
    },
    wishlistAlt: {
      type: String,
      default: '',
    },
    unwishlistAlt: {
      type: String,
      default: '',
    },
    isArticleWishlistEnabled: {
      type: Boolean,
      default: false,
    },
    isProductWishlistEnabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      currentGridData: this.initialdata.list ? this.initialdata : this.articles,
      smallScreen:
        MqHandler.getMqHandler().getMqForSize('small').selected ||
        MqHandler.getMqHandler().getMqForSize('medium').selected,
      dialogIsOpen: false,
      urlHash: window.location.hash,
    };
  },

  computed: {
    ...mapState('filterList', {
      filterDataset: (state) => state.filterDataset,
      showOverlay: (state) => state.loading,
      facetsOpened: (state) => state.facetsOpened,
    }),

    ...mapGetters('filterList', [
      'isLayoutTwoColumns',
      'tagsCollection',
      'selectedTags',
      'selectedBrands',
    ]),

    showFilterOptions() {
      return this.filterDataset.sortingOptions.length > 0 && this.filterDataset.list.length > 0;
    },

    totalResultsCount() {
      const productsResultsCount = this.initialdata.resultsCount;
      const articlesResultsCount = this.articles.resultsCount;

      return typeof productsResultsCount === 'number' && typeof articlesResultsCount === 'number'
        ? productsResultsCount + articlesResultsCount
        : typeof productsResultsCount === 'number'
        ? productsResultsCount
        : typeof articlesResultsCount === 'number'
        ? articlesResultsCount
        : 0;
    },
  },

  watch: {
    showOverlay(val) {
      if (val && this.facetsOpened) {
        document.body.classList.add('noScroll');
      } else {
        document.body.classList.remove('noScroll');
      }
    },
  },

  beforeCreate() {
    const localStore = createStore({});
    localStore.registerModule('filterList', store);
  },

  created() {
    this.setInitialItems(this.currentGridData);
    if (this.isLayoutSearchPage) {
      this.setLayoutSearchPage(this.isLayoutSearchPage);
    }
  },

  mounted() {
    eventBus.on('mediaquery::changed', (mq) => {
      this.smallScreen = !!(mq.size === 'small' || mq.size === 'medium');

      if (this.facetsOpened) {
        this.toggleFacets();
      }
    });

    eventBus.on('filterProducts', (payload) => {
      const { apiUrl, url } = payload;

      if (!apiUrl) return;

      this.setInitialItems({ clearAllFilter: true });
      this.getData(apiUrl, url ? url : false);
    });

    eventBus.on('resetFilterProducts', ({ url = false, apiURL }) => {
      this.setInitialItems({ clearAllFilter: true });
      this.getData(apiURL, url);
    });

    eventBus.on('closeFilterProductsDialog', () => {
      this.dialogIsOpen = false;
    });

    window.onpopstate = () => {
      window.location.href = document.location;
    };
    
    if(this.urlHash){
      this.scorllAfterPageloadwithHash();
    };
  },

  methods: {
    ...mapActions('filterList', [
      'setInitialItems',
      'getNewItems',
      'toggleFacets',
      'setLoadMore',
      'setLayoutSearchPage',
    ]),

    onToggleFacets() {
      this.toggleFacets();
      if (!this.facetsOpened) {
        eventBus.emit(HERO_VIDEO_UPDATE);
      }
    },

    getData(apiUrl, pushState = false) {
      return this.getNewItems(apiUrl).then(() => this.pushUrl(pushState || apiUrl));
    },

    pushUrl(url) {
      window.history.pushState({}, document.title, url);

      this.updateGoogleBotParameters(url);
    },

    switchTabAnalytics() {
      const label = this.currentGridData.dictionary.searchPageLabel;

      AnalyticsHandler.getAnalyticsHandler().push({
        type: 'userActionEvent',
        event_name: 'highlight_tab_button_click',
        cta_name: label,
        category: `highlight tab::${window.wsf.AnalyticsVariables.pageCategory}`,
        action: 'select',
        label,
      });
    },

    switchToProducts() {
      if (
        !(
          this.currentGridData.gridType === 'ProductsList' ||
          this.currentGridData.gridType === 'ProductsListTwoColumns'
        ) &&
        this.initialdata.list
      ) {
        this.currentGridData = this.initialdata;
        this.setInitialItems(this.currentGridData);
        this.switchTabAnalytics();
      }
    },

    switchToArticles() {
      if (
        !(
          this.currentGridData.gridType === 'ArticlesList' ||
          this.currentGridData.gridType === 'ArticlesListTwoColumns'
        ) &&
        this.articles.list
      ) {
        this.currentGridData = this.articles;
        this.setInitialItems(this.currentGridData);
        this.switchTabAnalytics();
      }
    },

    updateGoogleBotParameters(url) {
      let metaRobots = document.querySelector('meta[name="robots"]');

      if (!metaRobots) {
        metaRobots = document.createElement('meta');
        metaRobots.setAttribute('name', 'robots');
        document.head.appendChild(metaRobots);
      }

      metaRobots.setAttribute('content', 'noindex, follow');

      let canonicalLink = document.querySelector('link[rel="canonical"]');

      if (!canonicalLink) {
        canonicalLink = document.createElement('link');
        canonicalLink.setAttribute('rel', 'canonical');
        document.head.appendChild(canonicalLink);
      }

      canonicalLink.setAttribute('href', `${window.location.origin}${url}`);
    },
    scorllAfterPageloadwithHash(){
      const target = document.querySelector(this.urlHash);
      if (!target) return;

      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setTimeout(() => {
              target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 2000);
            obs.disconnect();
          }
        });
      }, {
        root : null,
        threshold: 0
      });

      observer.observe(target);
    }
  },
};
</script>
